// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"73cbb022","703":"d430fd16","925":"9962f6fc"}[chunkId] + ".chunk.js";
};